import React from 'react';
import { motion } from 'framer-motion';
import { Cookie } from 'lucide-react';

const CookieSettingsButton = ({ onClick }) => {
  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2, duration: 0.5 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={onClick}
      className="fixed bottom-6 left-6 z-[9998] bg-luxury-gold hover:bg-luxury-gold/90 text-white p-4 rounded-full shadow-2xl transition-all duration-300 group"
      aria-label="Cookie Einstellungen"
    >
      <Cookie size={24} className="group-hover:rotate-12 transition-transform duration-300" />
      
      {/* Tooltip */}
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-luxury-charcoal text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Cookie Einstellungen
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
          <div className="border-4 border-transparent border-t-luxury-charcoal"></div>
        </div>
      </div>
    </motion.button>
  );
};

export default CookieSettingsButton;
